import { useEffect } from 'react'
import type { ReactNode } from 'react'

/** Generiskt helskärmsläge för det som visas för eleverna på tavlan
 *  (startuppgift, aktivitetsuppgift, exit ticket): stor och avskalad layout,
 *  stängs med knapp eller Esc. Jfr STRUKTUR-OCH-WEBBPRESENTATION.md §6.3
 *  "Helskärmslägen (centralt!)". */
export default function Tavelvy({
  rubrik,
  onStang,
  children,
}: {
  rubrik: string
  onStang: () => void
  children: ReactNode
}) {
  useEffect(() => {
    const vidTangent = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onStang()
    }
    document.addEventListener('keydown', vidTangent)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', vidTangent)
      document.body.style.overflow = ''
    }
  }, [onStang])

  return (
    <div className="projektion" role="dialog" aria-modal="true" aria-label={rubrik}>
      <div className="projektion-huvud">
        <h1>{rubrik}</h1>
        <button type="button" className="knapp knapp-sekundar" onClick={onStang}>
          Stäng ✕
        </button>
      </div>
      <div className="tavelvy-innehall">{children}</div>
    </div>
  )
}
